var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandingLine768 = function SvgLandingLine768(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 394,
    height: 1026,
    fill: "none",
    className: "landing-line-768_svg__landing-line-768"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.563,
    d: "M281.001 0c0 32.465-23.774 60.033-55.886 64.805l-85.464 12.702c-32.838 4.88-57.15 33.072-57.15 66.272v80.259c0 33.871 25.278 62.415 58.901 66.509l113.197 13.781c33.623 4.094 58.902 32.638 58.902 66.509v52.012c0 35.054-27.02 64.183-61.976 66.812l-188.55 14.178C28.022 506.468 1 535.597 1 570.651v92.451c0 36.57 29.324 66.384 65.89 66.991l260.221 4.314c36.565.607 65.889 30.421 65.889 66.991v34.558c0 35.655-27.924 65.064-63.531 66.91l-189.437 9.82c-35.608 1.846-63.532 31.255-63.532 66.91v45.904"
  })));
};
export default SvgLandingLine768;